export default __webpack_public_path__ + "static/media/edit.8cdb1a9a.svg";